// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cw-a";
export var fulfillmentFormRail = "_cw-9";
export var headerTitleRow = "_cw-c";
export var orderDetailsWrapper = "_cw-7";
export var orderLinkTrigger = "_cw-2";
export var paymentInformationGrid = "_cw-h";
export var paymentSummaryColumn = "_cw-i";
export var shipmentContainer = "_cw-b";
export var shipmentDetailsMainPane = "_cw-8";
export var shipmentNavigationCard = "_cw-5";
export var shipmentNavigationRail = "_cw-3";
export var shipmentNavigationRailHeader = "_cw-4";
export var shipmentSummaryFact = "_cw-e";
export var shipmentSummaryGrid = "_cw-d";
export var shipmentSummaryMetadataRow = "_cw-f";
export var shipmentSummaryTags = "_cw-g";
export var shipmentWorkspace = "_cw-0";
export var shipmentWorkspaceContent = "_cw-6";
export var shipmentWorkspaceHeader = "_cw-1";